// extracted by mini-css-extract-plugin
export default {"container":"customisedItem_container__JoYnf","customisation":"customisedItem_customisation__4ncbA","item":"customisedItem_item__FupoH"};